<template>
	<b-container fluid v-if="laneClosureRequest != null && loaded">
		<lane-closure-request-quick-nav v-if="!$store.state.isMobile" v-model="laneClosureRequest" selected="report-closure"></lane-closure-request-quick-nav>
	<b-row>
	<b-col :cols="isHideMapAndDesktop ? '6' : null" :style="isHideMapAndDesktop ? 'flex: 0 0 56%; max-width: 56%' : null">
	<b-container class="report-closure-container">
		<b-row v-if="$store.state.isMobile">
			<b-col class="pt-0 lcr-quick-nav-summary lcr-quick-nav-summary-mobile" sm="12" xl="9">
				<div class="d-flex lcr-page-title">
					<div>
						<h1>Place / Remove Turning Restriction(s)</h1>
					</div>
				</div>
			</b-col>
		</b-row>
		<b-row :class="$store.state.isMobile ? 'lcr-detail-mobile-wrapper' : ''">
			<b-col v-if="!$store.state.isMobile" class="lcr-quick-nav-summary" sm="12">
				<b-row>
					<b-col>
						<h1>Place / Remove Turning Restriction(s)</h1>
					</b-col>
				</b-row>
				<b-row v-if="laneClosureRequest.requesterProjectName">
					<b-col class="pt-1">
						<h2>Project: {{laneClosureRequest.requesterProjectName}}</h2>
					</b-col>
				</b-row>
				<lane-closure-view-info v-model="laneClosureRequest"></lane-closure-view-info>
				<!-- <div class="d-flex lcr-main-summary">

					<div class="lcr-main-summary__info">
						<div class="lcr-summary__label">Info</div>
						<div class="lcr-summary__value" v-show="laneClosureRequest.trafficManagementRef.value">TM: {{laneClosureRequest.trafficManagementRef.value}}</div>
						<div class="lcr-summary__value">LCR: {{laneClosureRequest.id}}</div>


						<div class="lcr-summary__label">Requester</div>
						<div class="lcr-summary__value">
							<div v-if="laneClosureRequest.requester">{{laneClosureRequest.requester.firstName}} {{laneClosureRequest.requester.lastName}}</div>
							<div v-if="laneClosureRequest.altRequester.length > 0">
								<div v-for="contact in laneClosureRequest.altRequester" v-bind:key="'c'+contact.userId">{{contact.firstName}} {{contact.lastName}}</div>
							</div>
						</div>


					</div>
					<div class="lcr-main-summary__info flex-grow-1">
						<div class="lcr-summary__label">Affected Streets</div>
						<div class="lcr-summary__value">{{directionOfTravel}}</div>
						<div class="lcr-summary__value">{{laneClosureRequest.affectedStreet.value}}</div>
						<div class="lcr-summary__value">{{laneClosureRequest.firstCrossStreet.value}} to {{laneClosureRequest.lastCrossStreet.value}}</div>
					</div>
					<div class="lcr-main-summary__info pt-4">
						<div class="show-on-map-wrapper">
							<a class="show-on-map text-left" @click="showOnMap">
								<span v-if="hideMap" class="on-container">
									<img class="on-badge responsive-img" src="@/assets/map-badge-hide.svg" alt="on-badge" />
									<img class="on-map responsive-img" src="@/assets/hide-map.svg" alt="on-map" />
								</span>
								<span v-else class="on-container">
									<img class="on-badge responsive-img" src="@/assets/map-badge.svg" alt="on-badge" />
									<img class="on-map responsive-img" src="@/assets/show-on-map.svg" alt="on-map" />
								</span>
							</a>
						</div>
					</div>
					<div class="lcr-main-summary__info">
						<div class="lcr-summary__label">Primary Reason for Closure</div>
						<div class="lcr-summary__value">{{natureOfWork}}</div>
					</div>
					<div class="lcr-main-summary__info ">
						<div class="lcr-summary__label">Date(s)</div>
						<div class="lcr-summary__value">{{moment(laneClosureRequest.fromDate.value).format('MM/DD/YYYY')}} - {{moment(laneClosureRequest.toDate.value).format('MM/DD/YYYY')}}</div>
						<div class="lcr-summary__value">{{moment(laneClosureRequest.fromDate.value).format('H:mm')}} - {{moment(laneClosureRequest.toDate.value).format('H:mm')}}</div>
					</div>
					<div class="lcr-main-summary__info" v-if="laneClosureRequest.completeTypeId.value != null">
						<div class="lcr-summary__label">Complete Status</div>
						<div class="lcr-summary__value">{{LaneClosureRequest.getCompleteTypeIdText(laneClosureRequest.completeTypeId.value)}}</div>
					</div>
					<div class="lcr-main-summary__info">
						<div class="lcr-summary__label">Approval Status</div>
						<div class="lcr-summary__value">{{LaneClosureRequest.getApprovalStatusIdText(laneClosureRequest.approvalStatusId.value)}}</div>
						<div class="lcr-summary__label">Record Status</div>
						<div class="lcr-summary__value">{{LaneClosureRequest.getRecordStatusText(laneClosureRequest.recordStatusId.value)}}</div>
					</div>

				</div> -->

			</b-col>
			<b-col v-if="$store.state.isMobile" class="lcr-quick-nav-summary lcr-quick-nav-summary-mobile" sm="12">
				<lane-closure-view-info v-model="laneClosureRequest"></lane-closure-view-info>
			</b-col>
		</b-row>

		<div v-show="!canReportRestriction" class="mt-3">
			<div>
				<p style="font-weight:bold;" v-html="cannotReportReason"></p>
				<b-button @click="onViewLaneClosureRequest">View Request</b-button>
			</div>
		</div>
		<div v-show="canReportRestriction" class="pt-3">
				<h2 v-if="$store.getters.isReadOnly()">You do not have permission to report restrictions on this request.</h2>
					<h3 v-if="!$store.getters.isReadOnly()" v-show="!$store.state.isMobile">What restrictions are in effect for this report?</h3>
					<b-button v-if="!$store.getters.isReadOnly()" v-show="!$store.state.isMobile" @click="onAllInEffect" variant="light" class="close-button" type="button"><img src="/img/assets/set-all-close.svg" alt="" />All In Place</b-button>
					<b-button v-if="!$store.getters.isReadOnly()" v-show="!$store.state.isMobile" @click="onAllRemoved" variant="light" class="open-button" type="button"><img src="/img/assets/set-all-open.svg" alt="" />All Removed</b-button>



<!-- 					<b-button v-if="!$store.getters.isReadOnly()" class="mr-1" type="button" @click="onAllInEffect" v-show="!$store.state.isMobile">All In Place</b-button>
					<b-button v-if="!$store.getters.isReadOnly()" type="button" @click="onAllRemoved" v-show="!$store.state.isMobile">Removed</b-button> -->
					<br v-if="!$store.state.isMobile"/><br v-if="!$store.state.isMobile"/>
					<div class="mobile-restriction-title">
						<h1>Restriction(s)</h1>
						<p>Set in place/removed individually or use "Set All..." buttons below.</p>
					</div>
					<report-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(1,1)" :expand="expandCustomizeRestriction['1,1']" :restrictionTypeId="1" :directionId="1" v-bind:key="'viewrestrictionListing1-1-'+renderCounter" v-model="restriction.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-restriction-listing>
					<report-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(1,2)" :expand="expandCustomizeRestriction['1,2']" :restrictionTypeId="1" :directionId="2" v-bind:key="'viewrestrictionListing1-2-'+renderCounter" v-model="restriction.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-restriction-listing>
					<report-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(1,3)" :expand="expandCustomizeRestriction['1,3']" :restrictionTypeId="1" :directionId="3" v-bind:key="'viewrestrictionListing1-3-'+renderCounter" v-model="restriction.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-restriction-listing>
					<report-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(1,4)" :expand="expandCustomizeRestriction['1,4']" :restrictionTypeId="1" :directionId="4" v-bind:key="'viewrestrictionListing1-4-'+renderCounter" v-model="restriction.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-restriction-listing>
					<report-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(2,1)" :expand="expandCustomizeRestriction['2,1']" :restrictionTypeId="2" :directionId="1" v-bind:key="'viewrestrictionListing2-1-'+renderCounter" v-model="restriction.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-restriction-listing>
					<report-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(2,2)" :expand="expandCustomizeRestriction['2,2']" :restrictionTypeId="2" :directionId="2" v-bind:key="'viewrestrictionListing2-2-'+renderCounter" v-model="restriction.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-restriction-listing>
					<report-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(2,3)" :expand="expandCustomizeRestriction['2,3']" :restrictionTypeId="2" :directionId="3" v-bind:key="'viewrestrictionListing2-3-'+renderCounter" v-model="restriction.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-restriction-listing>
					<report-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(2,4)" :expand="expandCustomizeRestriction['2,4']" :restrictionTypeId="2" :directionId="4" v-bind:key="'viewrestrictionListing2-4-'+renderCounter" v-model="restriction.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-restriction-listing>
					<report-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(3,1)" :expand="expandCustomizeRestriction['3,1']" :restrictionTypeId="3" :directionId="1" v-bind:key="'viewrestrictionListing3-1-'+renderCounter" v-model="restriction.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-restriction-listing>
					<report-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(3,2)" :expand="expandCustomizeRestriction['3,2']" :restrictionTypeId="3" :directionId="2" v-bind:key="'viewrestrictionListing3-2-'+renderCounter" v-model="restriction.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-restriction-listing>
					<report-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(3,3)" :expand="expandCustomizeRestriction['3,3']" :restrictionTypeId="3" :directionId="3" v-bind:key="'viewrestrictionListing3-3-'+renderCounter" v-model="restriction.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-restriction-listing>
					<report-lane-closure-request-block-restriction-listing v-show="!isEditingBlock" v-if="hasRestrictionTypeId(3,4)" :expand="expandCustomizeRestriction['3,4']" :restrictionTypeId="3" :directionId="4" v-bind:key="'viewrestrictionListing3-4-'+renderCounter" v-model="restriction.block" :preset="laneClosureRequest.presetBlock"></report-lane-closure-request-block-restriction-listing>

					<h1 v-show="$store.state.isMobile && canSetTrafficEffect"><label for="ta-traffic-effect">Traffic Effect</label></h1>
					<div class="request__user__info" v-show="canSetTrafficEffect">
					<b-row >
						<b-col>
							<b-form-group label="Traffic Effect" label-for="ta-traffic-effect" :state="restriction.trafficEffect.status" :invalid-feedback="restriction.trafficEffect.invalidMessage">
								<wysiwyg id="ta-traffic-effect" rows="4" no-resize v-model="restriction.trafficEffect.value" @input="restriction.trafficEffect.resetStatus()" :state="restriction.trafficEffect.status">
								</wysiwyg>
							</b-form-group>
						</b-col>
					</b-row>
					</div>

					<h1 v-show="$store.state.isMobile">Attachments</h1>
					<div class="request__user__info">
					<b-row>
						<b-col sm="12">
							<div v-if="!$store.state.isMobile" class="lcr-summary__label">Attachments</div>
							<div v-if="!$store.getters.isReadOnly()" class="attachment__uploader">
							<file-pond credits="false" name="attachment" ref="pond" label-idle="<span class='filepond--label-action'>Select files</span>" v-bind:allow-multiple="true" 
								accepted-file-types="image/jpeg, image/png, application/pdf, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel,application/msexcel,application/x-msexcel,application/x-ms-excel,application/x-excel,application/x-dos_ms_excel,application/xls,application/x-xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.ms-powerpoint"
								v-on:init="handleFilePondInit" v-on:addfile="handleFilePondAddFile" v-on:processfilestart="handleFilePondProcessFileStart" v-on:processfiles="handleFilePondProcessAllFiles" v-on:processfileabort="handleFilePondProcessAbort" v-on:error="handleFilePondProcessError"  v-on:processfile="handleFilePondProcessFile">
							</file-pond>
							</div>
						</b-col>
						<b-col sm="12">
							<attachments-list  :sourceId="null" a:sourceTable="'r_attachment'" v-model="restriction" :downloadToken="downloadToken" :downloadTokenExpires="downloadTokenExpires" ></attachments-list>
						</b-col>
					</b-row>
					</div>

					<h1 v-show="$store.state.isMobile">Reporter</h1>
			<div class="request__user__info">
				<b-row v-if="!$store.getters.isReadOnly()">
					<b-col sm="12" lg="6">
						<b-form-group id="ig-primary-contact" label="Who is making this report?" label-for="input-lcr-primary-contact" description="" :state="selectReporter.status" :invalid-feedback="selectReporter.invalidMessage">
							<div v-if="reporter" class="contact">
								<div class="contact__name">{{reporter.firstName}} {{reporter.lastName}}</div>
								<div class="contact__organization">{{reporter.organizationName}}</div>
								<div class="contact__phone">{{reporter.phone}}</div>
							</div>
							<autocomplete data-position="above" v-if="!$store.getters.isReadOnly()" :search="SearchReporter" :get-result-value="SearchReporterValue" @submit="HandleSelectReporter" placeholder="Start typing to select Reporter" aria-label="Start typing to select Reporter" ref="searchReporter" auto-select>
								<template v-slot:result=" {result, props } ">
									<li v-bind="props" class="autocomplete-result primary-contact-result">
										<div class="contact-name">{{result.firstName}} {{result.lastName}}</div>
										<div class="contact-organization">{{result.organizationName}}</div>
										<div class="contact-phone">{{result.phone}}</div>
									</li>
								</template>
							</autocomplete>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row v-if="!$store.getters.isReadOnly()">
							<b-col class="pt-3" sm="12" md="12">
						<b-row>
							<b-col cols="12" md="6">
								<b-form-group id="ig-report-start-date" label="Reporting Date" label-for="input-report-start-date" :state="restriction.fromDateTime.status" :invalid-feedback="restriction.fromDateTime.invalidMessage">
									<date-picker :disabled=$store.getters.isReadOnly() bootstrap-styling id="input-report-start-date" format="MM/dd/yyyy" v-model="restriction.fromDateTime.value" :input-class="{'is-invalid': restriction.fromDateTime.status == false}" @input="restriction.fromDateTime.resetStatus(); checkLessThanTwoHours();" :typeable="true" :placeholder="'mm/dd/yyyy'"></date-picker>
								</b-form-group>
							</b-col>
							<b-col cols="12" md="6">
								<b-form-group id="ig-report-start-time" label="Reporting Time" label-for="input-report-start-time" :state="restriction.fromDateTime.status" :invalid-feedback="restriction.fromDateTime.invalidMessage">
									<bootstrap-text-time-picker ref="refTimeFrom" :disabled=$store.getters.isReadOnly() v-model="restriction.fromDateTime.value" v-on:update:time="onFromDateTimeChanged"></bootstrap-text-time-picker>
								</b-form-group>
							</b-col>
						</b-row>
							</b-col>
						</b-row>

						<b-row  v-if="canReportClosure && !$store.getters.isReadOnly()" >
							<b-col class="mt-2">
								<b-form-group label="Close or re-open lanes after saving this report?">
									<div class="yes-no-switch-field">
											<input id="reportClosureAfter" :disabled=$store.getters.isReadOnly()  class="yes-no-switch" :checked="setClosuresAfter == true" type="checkbox" @change="setClosuresAfter = !setClosuresAfter" >
											<label for="reportClosureAfter"></label>
									</div>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row v-if="!$store.getters.isReadOnly()" v-show="!$store.state.isMobile">
							<b-col class="mt-2">
								<b-button :disabled="isButtonDisabled" variant="primary" class="mr-1" type="button" @click="onSubmitOnly">Save Restriction Report <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner>
								</b-button>
								<b-button variant="text" class="mr-1" type="button" @click="onCancel">Cancel Report</b-button>
							</b-col>
						</b-row>
			</div>
			
			<div style="height: 25px;" v-show="$store.state.isMobile"></div>



			<div class="actions-bar" v-show="$store.state.isMobile">
				<div class="d-flex">
					<div class="actions-bar__close"><b-button @click="onAllInEffect" variant="light" class="ineffect-button" type="button"><img src="/img/assets/set-all-close.svg" alt="" />In Place</b-button></div>
					<div class="actions-bar__open"><b-button @click="onAllRemoved" variant="light" class="off-button" type="button"><img src="/img/assets/set-all-open.svg" alt="" />Removed</b-button></div>
					<div class="actions-bar__save"><b-button :disabled="isButtonDisabled" @click="onSubmitOnly" variant="primary" class="save-button" type="button"><b-spinner small label="Saving..." class="mr-2" v-if="saving"></b-spinner><span v-if="!saving" class="btn__icon"><img src="/img/assets/icon-checkmark.svg"/></span><span class="btn__text">Save</span></b-button></div>
				</div>
			</div>
		</div>
	</b-container>
	</b-col>
	<b-col cols="6" style="flex: 0 0 44%; max-width: 44%" v-if="hideMap">
	</b-col>
	</b-row>
	<!-- leaving page -->
	<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
		<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
		<template v-slot:modal-footer="{ ok }">
			<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
			<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
			<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
		</template>
	</b-modal>

	</b-container>
	<Spinner v-else />
</template>
<script>
import LaneClosureRequest from '../../models/LaneClosureRequest';
import LaneClosureRequestQuickNav from '../../components/LaneClosureRequestQuickNav.vue';
import LaneClosureViewInfo from '../../components/LaneClosureViewInfo.vue';
import LaneClosureRequestBlock from '../../models/LaneClosureRequestBlock';
import Restriction from '../../models/Restriction';
import ErrorHandler from '../../utility/ErrorHandler';

import Datepicker from 'vuejs-datepicker';
import BootstrapField from '../../utility/BootstrapField';
import BootstrapTextTimePicker from '../../components/bootstrap-text-time-picker.vue';
import Autocomplete from '@trevoreyre/autocomplete-vue'

import Spinner from "./../../components/Spinner.vue";

import Format from '../../utility/Format';

import { gmapApi } from 'gmap-vue'
import KMLHelper from '../../utility/KMLHelper';

import Attachment from '../../models/Attachment';

import AttachmentsList from '../../components/AttachmentsList.vue';
// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileMetadata from 'filepond-plugin-file-metadata';
import FilePondPluginFileRename from 'filepond-plugin-file-rename';


import ReportLaneClosureRequestBlockRestrictionListing from '../../components/ReportLaneClosureRequestBlockRestrictionListing';
import Vue from 'vue'
export default {
	name: 'ReportRestriction',
	docTitle() {
		return `Request ${this.id} Report Restriction - Lane Closures`
	},

	components: {
		LaneClosureViewInfo,
		LaneClosureRequestQuickNav,
		Autocomplete,
		'date-picker': Datepicker,
		BootstrapTextTimePicker,
		'attachments-list': AttachmentsList,
		FilePond: vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileMetadata, FilePondPluginFileRename),
		ReportLaneClosureRequestBlockRestrictionListing,
		Spinner,
	},
	props: ['id'],
	data() {
		return {
			overrideUnsavedChanges: false,
			// Editable methods for the modal.
			modalOnSave: () => {},
			modalOnLeave: () => {},
			map: null,
			mapPaths: null,
			mapPlacemarks: [],
			Attachment,
			downloadToken:null,
			downloadTokenExpires:null,

			expandCustomizeRestriction: [],
			markers: [],
			isEditingBlock: false,
			LaneClosureRequest,
			laneClosureRequest: null,
			submitted: null,
			allStreetOptions: [],
			noFirstCrossStreetOptions: [{
				text: 'Select Affected Street',
				value: null
			}],
			noLastCrossStreetOptions: [{
				text: 'Select First Cross Street',
				value: null
			}],
			file: null,
			restriction: null,
			newRestriction: {
				blockId: new BootstrapField({
					value: null,
				}),
				laneId: new BootstrapField({
					value: null,
				}),
				restrictionTypeId: new BootstrapField({
					value: 1,
				}),
				affectedStreet: new BootstrapField({
					value: null,
				}),
				crossStreet: new BootstrapField({
					value: null,
				})
			},
			onSubmitPromiseDeferred: {
				resolve: null,
				reject: null
			},
			renderCounter: 0,
			saving: false,
			showUnsavedChangesModal: false,
			setClosuresAfter: false,
			lineIndexError: null,
			isButtonDisabled: false,
			saveState: null,
			modalRequiredFieldList: [],
			selectReporter: new BootstrapField({
				value: null,
			}),
			showRequiredFieldModal: false,
			requesterProjectInfo: null, // have to save the project information, in case they change the user, the project will be gone.
			ownerInfo: null,
			reporter: null,
			refSearchReporter: null,
			show: true,
			hideMap: false,
		}
	},
	mounted() {
		this.collapseAll();
		this.setEventBusOn();

		// TODO: verify their permissions for this lane closure request.
		// this.getPermission();
		this.LoadLaneClosureRequest(this.$route.params.id);

		// vm.LoadLaneClosureRequest(this.$route.params.id);
		var main = document.getElementById("main");
		main.scrollTo(0, 0);
	},
	computed: {
		isHideMapAndDesktop() {
			return this.hideMap && !this.$store.state.isMobile;
		},

		canSetTrafficEffect() {
			if (this.laneClosureRequest) {
				if (this.$store.getters.userHasRole('internal_admin_requests')) {
					return true;
				}
			}
			return false;
		},
		cannotReportReason() {
			var hasRestrictions = false;
			let text = null;
			if (this.laneClosureRequest) {
				if (this.laneClosureRequest.approvalStatusId.value == 2) {
					if (this.laneClosureRequest.recordStatusId.value != 7) {
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							if (this.laneClosureRequest.block[x].restriction) {
								if (this.laneClosureRequest.block[x].restriction.length > 0) {
									hasRestrictions = true;
								}
							}
						}
						if (!hasRestrictions ) {
							text = "This request does not have any turn restrictions.";
						}
					} else {
						text = "This request was already completed.";
					}
				} else {
					text = "This request cannot have restrictions reported until it is Approved.";
				}
			}
			if (text == null) {
				if (!this.canReportRestriction) {
					text = "You do not have permission to report turn restrictions in place or removed for this request.";
				}
			}

			return text;
		},

		canReportRestriction() {
			if (this.laneClosureRequest && this.$store.getters.userInfo()) {
				if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
					let canReport = false;
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canReportOrg = this.$store.getters.userHasPermission('rr_org');
					let canReportMine = this.$store.getters.userHasPermission('rr_mine');
					let canReportAll = this.$store.getters.userHasPermission('rr_all');

					if (!canReportMine && !canReportAll && !canReportOrg) {
						return false;
					}

					if (canReportAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.restrictionReporterId == thisUserId && (canReportOrg || canReportMine)) {
							canReport = true;
						}
						if (this.laneClosureRequest.requesterId == thisUserId && (canReportOrg || canReportMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];


					if (!canReport) {
						if (canReportOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canReportOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}

					if (!canReport) {
						if (this.laneClosureRequest.altRestrictionReporter) {
							for (x = 0; x < this.laneClosureRequest.altRestrictionReporter.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRestrictionReporter[x].userId + "") {
									canReport = true;
								}
								if (canReport == false) {
									if (canReportOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRestrictionReporter[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}

						}
					}

					if (canReport) {
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							if (this.laneClosureRequest.block[x].restriction.length > 0) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},

		canReportClosure() {
			let canReport = false;
			if (this.laneClosureRequest && this.$store.getters.userInfo()) {
				if (this.laneClosureRequest.approvalStatusId.value == 2 && this.laneClosureRequest.recordStatusId.value != 7) {
					let thisUserId = this.$store.getters.userId();
					let thisOrgId = this.$store.getters.userInfo().organizationId;
					let canReportOrg = this.$store.getters.userHasPermission('rlc_org');
					let canReportMine = this.$store.getters.userHasPermission('rlc_mine');
					let canReportAll = this.$store.getters.userHasPermission('rlc_all');



					if (!canReportMine && !canReportAll && !canReportOrg) {
						return false;
					}

					if (canReportAll) {
						canReport = true;
					}

					if (!canReport) {
						if (this.laneClosureRequest.closureReporterId == thisUserId && (canReportOrg || canReportMine)) {
							canReport = true;
						}
						if (this.laneClosureRequest.requesterId == thisUserId && (canReportOrg || canReportMine)) {
							canReport = true;
						}
					}

					let x = 0;
					let orgs = [];


					if (!canReport) {
						if (canReportOrg) {
							orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.requester);
							console.log(orgs);
							if (orgs.includes(""+thisOrgId)) {
								canReport = true;
							}
						}
					}
					if (!canReport) {
						if (this.laneClosureRequest.altRequester) {
							for (x = 0; x < this.laneClosureRequest.altRequester.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altRequester[x].userId + "") {
									canReport = true; // they can always report if they are an alternate requester...
								}
								if (canReport == false) {
									if (canReportOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altRequester[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}
						}
					}

					if (!canReport) {
						if (this.laneClosureRequest.altClosureReporter) {
							for (x = 0; x < this.laneClosureRequest.altClosureReporter.length; x++) {
								if (thisUserId + "" == this.laneClosureRequest.altClosureReporter[x].userId + "") {
									canReport = true;
								}
								if (canReport == false) {
									if (canReportOrg) {
										orgs = this.getOrganizationIdTreeList(this.laneClosureRequest.altClosureReporter[x]);
										if (orgs.includes(""+thisOrgId)) {
											canReport = true;
										}
									}
								}
							}

						}
					}

					if (canReport) {
						let x = 0;
						for (x = 0; x < this.laneClosureRequest.block.length; x++) {
							if (this.laneClosureRequest.block[x].lane) {
								if (this.laneClosureRequest.block[x].lane.length > 0) {
									return true;
								}
							}
							if (this.laneClosureRequest.block[x].bicycle) {
								if (this.laneClosureRequest.block[x].bicycle.length > 0) {
									return true;
								}
							}
							if (this.laneClosureRequest.block[x].sidewalk) {
								if (this.laneClosureRequest.block[x].sidewalk.length > 0) {
									return true;
								}
							}
						}
					}
				}
			}
			return false;
		},

		googleMap: gmapApi,
		disableStartDate() {
			return {
				to: new Date()
			};
		},
		disableEndDate() {
			if (this.laneClosureRequest.fromDate && this.laneClosureRequest.fromDate.value) {
				return { to: new Date(this.laneClosureRequest.fromDate.value) };
			}

			//return {to: new Date()};
			return {};
		},
		friendlyFromToDate() {
			// let diff = Format.diffYMDHMS(this.laneClosureRequest.fromDate.value, this.laneClosureRequest.toDate.value);
			return null;
		},
		directionOfTravel() {
			if (this.laneClosureRequest.directionId.value) {
				return Format.searchById(this.laneClosureRequest.directionId.value, LaneClosureRequest.getDirectionIdOptions).name;
			}
			return null;
		},
		getPeakIdText() {
			if (this.laneClosureRequest.peakId.value) {
				return Format.searchById(this.laneClosureRequest.peakId.value, LaneClosureRequest.getClosurePeakReason).name;
			}
			return null;
		},

		natureOfWork() {
			if (this.laneClosureRequest.natureOfWorkId.value) {
				return Format.searchById(this.laneClosureRequest.natureOfWorkId.value, LaneClosureRequest.getNatureOfWorkOptions).name;
			}
			return null;
		}
	},

	watch: {
		'$route.params': function() {
			// for changing route within the same component
			this.LoadLaneClosureRequest(this.$route.params.id);
		},
	},

	beforeDestroy() {
		this.setEventBusOff();
	},
	methods: {
		collapseAll() {
			this.expandCustomizeRestriction["1,1"] = false;
			this.expandCustomizeRestriction["1,2"] = false;
			this.expandCustomizeRestriction["1,3"] = false;
			this.expandCustomizeRestriction["1,4"] = false;
			this.expandCustomizeRestriction["2,1"] = false;
			this.expandCustomizeRestriction["2,2"] = false;
			this.expandCustomizeRestriction["2,3"] = false;
			this.expandCustomizeRestriction["2,4"] = false;
			this.expandCustomizeRestriction["3,1"] = false;
			this.expandCustomizeRestriction["3,2"] = false;
			this.expandCustomizeRestriction["3,3"] = false;
			this.expandCustomizeRestriction["3,4"] = false;
		},
		anyExpanded() {
			var isExpanded = false;
			for (var x in this.expandCustomizeRestriction) {
				if (this.expandCustomizeRestriction[x] == true) {
					isExpanded = true;
				}
			}
			if (isExpanded) {
				return true;
			}
			return false;
		},
		getOrganizationIdTreeList(user) {
			if (user.organizationIdTree) {
				let treeString = user.organizationIdTree;
				let treeList = treeString.split("|");
				treeList.pop();
				treeList.shift();
				treeList.reverse();
				return treeList;
			} else {
				return new Array(user.organizationId);
			}
		},
		modalOnCancel() {
			this.showUnsavedChangesModal = false;
		},
		forceRerender() {
			this.renderCounter += 1;
			this.blockDetailsKey = "blockDetailsKey-" + this.renderCounter;
			this.blockClosuresRestrictionsKey = "blockClosuresRestrictionsKey-" + this.renderCounter;
			this.blockEditDetailsKey = "blockEditDetailsKey-" + this.renderCounter;
			this.forceRerenderBlockEditDetails();
		},
		forceRerenderBlockEditDetails() {
			this.blockEditDetailsKeyCounter += 1;
			this.blockEditDetailsKey = "blockEditDetailsKey-" + this.blockEditDetailsKeyCounter;
		},
		onToggleExpandCustomizeRestriction(value) {
			this.expandCustomizeRestriction["" + value.restrictionTypeId + "," + value.directionId] = value.expand;
			this.forceRerender();
		},

		hasRestrictionTypeId(id, directionId) {
			let found = false;
			let xx = 0;
			let x = 0;
			if (this.laneClosureRequest) {
				for (xx = 0; xx < this.laneClosureRequest.block.length; xx++) {
					if (this.laneClosureRequest.block[xx].restriction) {
						for (x = 0; x < this.laneClosureRequest.block[xx].restriction.length; x++) {
							if (this.laneClosureRequest.block[xx].restriction[x].restrictionTypeId.value + "" == "" + id &&
								this.laneClosureRequest.block[xx].restriction[x].directionId.value + "" == "" + directionId) {
								found = true;
							}
						}
					}
				}
			}
			return found;
		},

		setEventBusOff() {
			this.$bus.$off('report-restriction-map:block-clicked', this.onMapBlockClick);
			this.$bus.$off('report-restriction:toggle-restriction-in-effect', this.toggleRestrictionInEffect);
			this.$bus.$off('block:list-expand-restriction', this.onToggleExpandCustomizeRestriction);
			this.$bus.$off('report-restriction:all-restrictions-in-effect', this.toggleAllRestrictionsInEffect);
			this.$bus.$off('block:show-on-map', this.showBlockOnMap);

			this.$bus.$off('swipe:right', this.onSwipeRight);


			this.$bus.$off('map:shown', this.changeToHideMap);
			this.$bus.$off('map:hidden', this.changeToShowMap);

			this.$bus.$off("attachment:updateComment",this.SaveAttachmentComment);
			this.$bus.$off("attachment:autoSave",this.SaveAttachmentComment);
			this.$bus.$off("attachment:delete", this.deleteAttachment);
		},
		setEventBusOn() {
			this.setEventBusOff();
			this.$bus.$on('report-restriction-map:block-clicked', this.onMapBlockClick);
			this.$bus.$on('report-restriction:toggle-restriction-in-effect', this.toggleRestrictionInEffect);
			this.$bus.$on('report-restriction:all-restrictions-in-effect', this.toggleAllRestrictionsInEffect);

			this.$bus.$on('block:list-expand-restriction', this.onToggleExpandCustomizeRestriction);
			this.$bus.$on('block:show-on-map', this.showBlockOnMap);

			this.$bus.$on('swipe:right', this.onSwipeRight);
			this.$bus.$on('map:shown', this.changeToHideMap);
			this.$bus.$on('map:hidden', this.changeToShowMap);

			this.$bus.$on("attachment:updateComment",this.SaveAttachmentComment);
			this.$bus.$on("attachment:autoSave",this.SaveAttachmentComment);
			this.$bus.$on("attachment:delete", this.deleteAttachment);
		},
		SaveAttachmentComment(obj) {
			if (obj.comments != null && obj.comments != "" && obj.attachmentId != null) {
				let postData = {
					comments: obj.comments
				}
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/attachment/${obj.attachmentId}/comment?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: postData
				}).then(resp => {

				}).catch(error => {
					this.isButtonDisabled = false;
					if (error) {
						Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
					}
					// if (!ErrorHandler.HasLoginErrorCode(error)) {
					// 	// this.laneClosureRequest.SetErrors(error.response.data);
					// 	this.showErrors(error.response.data.fields);
					// } else {
					// 	// ErrorHandler.RedirectToLogin();
					// }
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},
		deleteAttachment(obj) {
			//edit request tab DCZ, Transit, Parking
			this.isButtonDisabled = true;
			if (obj.userId != null && obj.attachmentId != null) {
				Vue.prototype.$http({
					method: 'delete',
					url: `${this.$store.state.apiUrl}/attachment/${obj.attachmentId}/delete?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: obj
				}).then(resp => {
					if(resp.status === 200){
						// Find the index of the attachment with the given id
						const index = this.restriction.attachment.findIndex((attachment) => attachment.id === obj.attachmentId);
						// If found, remove it from the array TO hide the deleted attachment tile from view
						if (index !== -1) {
							this.restriction.attachment.splice(index, 1);
						}
					}
				}).catch(error => {
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						if (error.response) {
							this.restriction.SetErrors(error.response.data);
							this.showErrors(error.response.data.fields);
						}
					}
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},

		handleFilePondAddFile(e, file, m) {},
		handleFilePondInit: function() {
			this.$refs.pond._pond.setOptions({
				server: {
					header: {
						Authorization: "Bearer " + this.$store.state.token
					},
					process: {
						method: 'POST',
						url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
						withCredentials: true
					},
				}
			});
			this.$refs.pond._pond.setOptions({
				fileMetadataObject: {
					comments: null
				},
				allowImagePreview: false,
				allowRevert: false,
				allowReorder: false,
				allowReplace: false,
				server: {
					url: `${this.$store.state.apiUrl}/attachment/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					headers: {
						Authorization: "Bearer " + this.$store.state.token
					}
				}
			});
		},

		handleFilePondProcessFileStart(e,p) {
			this.isButtonDisabled = true;
		},
		handleFilePondProcessAllFiles(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessError(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessAbort(e,p) {
			this.isButtonDisabled = false;
		},
		handleFilePondProcessFile(e, p) {
			if (p.error) {
				// there was a problem!
			} else {
				let attachmentData = JSON.parse(p.serverId);
				this.downloadToken = attachmentData.downloadToken;
				this.downloadTokenExpires = attachmentData.downloadTokenExpires;
				this.restriction.attachment.unshift(new Attachment(attachmentData.attachment));
			}
		},
		toggleRestrictionInEffect(obj) {
			if (this.restriction.block[obj.block].restriction[obj.restriction].inEffect.value == 1) {
				this.restriction.block[obj.block].restriction[obj.restriction].inEffect.value = 0;
			} else {
				this.restriction.block[obj.block].restriction[obj.restriction].inEffect.value = 1;
			}
		},
		toggleAllRestrictionsInEffect(data) {
			for (var x = 0; x < this.restriction.block.length; x++) {
				for (var xx = 0; xx < this.restriction.block[x].restriction.length; xx++) {
					if (
						this.restriction.block[x].restriction[xx].restrictionTypeId.value == data.restrictionTypeId
						&& this.restriction.block[x].restriction[xx].directionId.value == data.directionId
					) {
						this.restriction.block[x].restriction[xx].inEffect.value = data.inEffect;
					}
				}
			}
		},
		toggleSidewalkInEffect(obj) {
			if (this.restriction.block[obj.block].sidewalk[obj.sidewalk].inEffect.value == 1) {
				this.restriction.block[obj.block].sidewalk[obj.sidewalk].inEffect.value = 0;
			} else {
				this.restriction.block[obj.block].sidewalk[obj.sidewalk].inEffect.value = 1;
			}
		},
		toggleBicycleInEffect(obj) {
			if (this.restriction.block[obj.block].bicycle[obj.bicycle].inEffect.value == 1) {
				this.restriction.block[obj.block].bicycle[obj.bicycle].inEffect.value = 0;
			} else {
				this.restriction.block[obj.block].bicycle[obj.bicycle].inEffect.value = 1;
			}
		},

		onAllRemoved() {
			let x = 0;
			let xx = 0;
			for (x = 0; x < this.restriction.block.length; x++) {
				for (xx = 0; xx < this.restriction.block[x].restriction.length; xx++) {
					this.restriction.block[x].restriction[xx].inEffect.value = 0;
				}
			}
			// this.$refs.blockDetails.setAllRestrictionsRemoved();
		},

		onAllInEffect() {
			if (this.restriction.block) {
				let x = 0;
				let xx = 0;
				for (x = 0; x < this.restriction.block.length; x++) {
					for (xx = 0; xx < this.restriction.block[x].restriction.length; xx++) {
						this.restriction.block[x].restriction[xx].inEffect.value = 1;
					}
				}
			}
			// this.$refs.blockDetails.setAllRestrictionsInEffect();
		},
		getBicycleText(bicycleId) {
			if (bicycleId) {
				return Format.searchById(bicycleId, LaneClosureRequest.getAffectBicycleOptions).name;
			}
			return "N/A";
		},

		getRestrictionPeakIdText(id) {
			if (id) {
				return Format.searchById(id, LaneClosureRequest.getRestrictionPeakReason).name;
			}
			return null;
		},
		getDirectionText(id) {
			if (id) {
				return Format.searchById(id, LaneClosureRequest.getDirectionIdOptions).name;
			}
			return null;
		},

		getRestrictionDirectionText(id) {
			if (id) {
				return Format.searchById(id, LaneClosureRequest.getRestrictionDirectionIdOptions).name;
			}
			return null;
		},
		getLanePeakReasonText(peakId) {
			if (peakId) {
				return Format.searchById(peakId, LaneClosureRequest.getClosurePeakReason).name;
			}
			return null;
		},
		getLaneText(laneId) {
			if (laneId) {
				return Format.searchByGroupedId(laneId, LaneClosureRequest.getLaneAffectedOptions).name;
			}
			return null;
		},

		getParkingLaneRemovedText(laneId) {
			if (laneId) {
				return Format.searchById(laneId, LaneClosureRequest.getParkingLaneOptions).name;
			}
			return null;
		},

		getTransitText(transitId) {
			if (transitId !== null) {
				return Format.searchById(transitId, LaneClosureRequest.getAffectTransitOptions).name;
			}
			return null;
		},

		getParkingRemovalText(parkingRemovalId) {
			if (parkingRemovalId !== null) {
				return Format.searchById(parkingRemovalId, LaneClosureRequest.getParkingRemoveOptions).name;
			}
			return null;
		},
		getWorkDoneForText(workId) {
			if (workId) {
				return Format.searchById(workId, LaneClosureRequest.getMajorUtilitiesOptions).name;
			}
			return null;
		},



		getRestrictionTypeText(restrictionTypeId) {
			if (restrictionTypeId) {
				return Format.searchById(restrictionTypeId, LaneClosureRequest.getTurningRestrictionTypeOptions).name;
			}
			return null;
		},

		getLaneImage(laneId) {
			if (laneId) {
				return Format.searchByGroupedId(laneId, LaneClosureRequest.getLaneAffectedOptions).img;
			}
			return null;
		},
		getRestrictionImage(restrictionTypeId) {
			if (restrictionTypeId) {
				return Format.searchById(restrictionTypeId, LaneClosureRequest.getTurningRestrictionTypeOptions).img;
			}
			return null;
		},

		getLeftTurnSignalText(turn) {
			if (turn !== null) {
				return Format.searchById(turn, LaneClosureRequest.getYesNoOptions).name;
			}
			return "N/A";
		},

		getYesNoText(val) {
			if (val !== null) {
				return Format.searchById(val, LaneClosureRequest.getYesNoOptions).name;
			}
			return null;
		},

		getSidewalkText(sidewalkId) {
			if (sidewalkId) {
				return Format.searchById(sidewalkId, LaneClosureRequest.getSidewalkOptions).name;
			}
			return "N/A";
		},

		getDczRequiredText(dcz) {
			if (dcz) {
				return Format.searchById(dcz, LaneClosureRequest.getYesNoOptions).name;
			}
			return "N/A";
		},

		getBicycleLaneText(bicycleId) {
			if (bicycleId) {
				return Format.searchById(bicycleId, LaneClosureRequest.getBicycleLaneOptions).name;
			}
			return "N/A";
		},

		showOnMap(index) {
			Vue.prototype.$bus.$emit("map:toggle", null, null);
			this.$nextTick(() => {
				// this.$store.dispatch("map/zoomToLaneClosureRequestId", this.laneClosureRequest.id);
				this.$store.dispatch("map/zoomAllBlocks", null);
				let x = 0;
				for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
					if (this.$store.getters["map/polylines"][x]) {
						if (this.$store.getters["map/polylines"][x].blockData) {
							this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#293C7C' });
						}
					}
				}
			});
		},
		showBlockOnMap(data) {
			let id;
			if (data instanceof Object) {
				id = data.id;
			}
			else {
				id = data;
			}
			if (this.currentBlockOnMap && this.currentBlockOnMap instanceof Object) {
				if (this.currentBlockOnMap.id == data.id && this.currentBlockOnMap.type == data.type && this.currentBlockOnMap.laneId == data.laneId && this.currentBlockOnMap.streetName == data.streetName ) {
					Vue.prototype.$bus.$emit("map:toggle", 0);
					this.currentBlockOnMap = null;
					return;
				}
			}

			this.currentBlockOnMap = data;
			Vue.prototype.$bus.$emit("map:toggle", 1);
			this.$nextTick(() => {
				this.$store.dispatch("map/zoomToBlockId", id);
				/*
				for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == id) {
						// this.zoomToBlock(x);
						// this.setPolylineColours(x);
						this.$store.dispatch("map/zoomToBlockIdPopup", id);

						break;
					}
				}
				*/
				let foundIndex = null;
				for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
					if (this.laneClosureRequest.block[x].blockId == id) {
						this.zoomToBlock(x);
						this.setPolylineColours(x);
						foundIndex =x;
						break;
					}
				}
				if (foundIndex != null) {
					this.$bus.$emit('map:block-closure-popup', {polyline:this.$store.getters["map/polylines"][foundIndex], e:null});
				}
			});
		},
		zoomAllBlocks() {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			if (this.restriction.block) {
				let x = 0;
				let z = 0;
				for (x = 0; x < this.restriction.block.length; x++) {
					if (this.restriction.block[x].mapPolyline) {
						let polyBounds = this.restriction.block[x].mapPolyline.getPath();
						for (z = 0; z < polyBounds.length; z++) {
							bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
						}

						setBounds = true;
					}
				}
			}
			if (setBounds) {
				this.$store.state.map.map.fitBounds(bounds);
			}
		},
		zoomToBlockId(id) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			if (this.restriction.block) {
				let x = 0;
				let z = 0;
				for (x = 0; x < this.restriction.block.length; x++) {
					if (this.restriction.block[x].mapPolyline && this.restriction.block[x].blockId == id) {
						let polyBounds = this.restriction.block[x].mapPolyline.getPath();
						for (z = 0; z < polyBounds.length; z++) {
							bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
						}

						setBounds = true;
					}
				}
			}
			if (setBounds) {
				this.$store.state.map.map.fitBounds(bounds);
			}
		},
		zoomToBlock(index) {
			var bounds = new google.maps.LatLngBounds();
			let setBounds = false;
			let x = 0;
			let z = 0;
			if (this.laneClosureRequest.block[index]) {
				if (this.$store.getters["map/polylines"]) {
					for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
						if (this.$store.getters["map/polylines"][x]) {
							if (this.$store.getters["map/polylines"][x].blockData) {
								if (this.$store.getters["map/polylines"][x].blockData.blockId == this.laneClosureRequest.block[index].blockId) {
									let polyBounds = this.$store.getters["map/polylines"][x].getPath();
									for (z = 0; z < polyBounds.length; z++) {
										bounds.extend(new google.maps.LatLng(polyBounds.getAt(z).lat(), polyBounds.getAt(z).lng()));
									}
									setBounds = true;
								}
							}
						}
					}
				}
			}
			if (setBounds) {
				this.$store.state.map.map.fitBounds(bounds);
			}
		},

		setPolylineColours(index) {
			let x = 0;
			for (x = 0; x < this.$store.getters["map/polylines"].length; x++) {
				if (this.$store.getters["map/polylines"][x]) {
					if (this.$store.getters["map/polylines"][x].blockData) {
						if (this.$store.getters["map/polylines"][x].blockData.blockId == this.laneClosureRequest.block[index].blockId) {
							this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#F2B942' });
						} else {
							this.$store.getters["map/polylines"][x].setOptions({ strokeColor: '#293C7C' });


						}
					}
				}
			}

		},

		setBlockPolyline(block) {
			let that = this;
			let foundIndex = null;
			let blockPolyline = null;
			if (block) {
				// find the existing marker/placemark.
				if (this.restriction.block) {
					for (var x = 0; x < this.restriction.block.length; x++) {
						if (this.restriction.block[x].blockId == block.blockId) {
							foundIndex = x;
							if (that.$store.getters["map/polylines"]) {
								for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x]) {
										if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
											blockPolyline = that.$store.getters["map/polylines"][x];
										}
									}
								}
							}
						}
					}
				}
				if (foundIndex == null || blockPolyline == null) {
					// add the block to the map.
					// look for existing block in lane closure request, and select it.
					var myParser = new Vue.prototype.$geoXML3.parser({
						map: null,
						afterParse: function(doc) {
							let xx = 0;
							var coords = [];
							let zz = 0;
							for (xx = 0; xx < doc[0].gpolylines[0].latLngs.length; xx++) {
								for (zz = 0; zz < doc[0].gpolylines[0].latLngs.getAt(xx).length; zz++) {
									coords.push(new google.maps.LatLng(doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lat(), doc[0].gpolylines[0].latLngs.getAt(xx).getAt(zz).lng()));
								}
							}
							let mapPolyline = new google.maps.Polyline({
								map: that.$store.state.map.map,
								path: coords,
								strokeColor: '#666666',
								strokeOpacity: 1.0,
								strokeWeight: 8
							});
							mapPolyline.blockData = block;
							let mapIndex = -1;
							if (foundIndex == null) {
								let newBlock = new LaneClosureRequestBlock(block);
								that.laneClosureRequest.block.push(newBlock);
								foundIndex = that.laneClosureRequest.block.length - 1;
							}
							if (that.$store.getters["map/polylines"]) {
								for (x = 0; x < that.$store.getters["map/polylines"].length; x++) {
									if (that.$store.getters["map/polylines"][x]) {
										if (that.$store.getters["map/polylines"][x].blockData.blockId == block.blockId) {
											that.$store.commit("map/setPolylineByIndex", x, mapPolyline);
											mapIndex = x;
										}
									}
								}
							}
							if (mapIndex == -1) {
								// not found, so add the polyline.
								that.$store.commit("map/addPolyline", mapPolyline);
							}
							google.maps.event.addListener(mapPolyline, 'click', function() {
								if (that.$bus) {
									that.$bus.$emit('report-restriction-map:block-clicked', this.blockData.blockId);
								}
							});
							return;
						}
					});
					let kmlString = "";
					if (block.kml != "") {
						let color = "7fff0000";
						if (block.streetName != that.laneClosureRequest.affectedStreet.value) {
							// turning restriction
							color = "7f000000"
						}
						kmlString += KMLHelper.createPlaceMarkFromGeometry(block.blockId, block.streetName, block.fromStreet, block.toStreet, block.kml, color, "8");
						kmlString = KMLHelper.finalizeKml(kmlString);
						myParser.parseKmlString(kmlString);
					}
				}
			}
		},

		onMapBlockClick: function(id) {
			let foundIndex = null;
			for (var x = 0; x < this.laneClosureRequest.block.length; x++) {
				if (this.laneClosureRequest.block[x].blockId == id) {
					this.zoomToBlock(x);
					this.setPolylineColours(x);
					foundIndex =x;
					break;
				}
			}
			if (foundIndex != null) {
				this.$bus.$emit('map:block-closure-popup', {polyline:this.$store.getters["map/polylines"][foundIndex], e:null});
			}
		},


		emailHref(value) {
			return "mailto:" + value;
		},

		onRemoveRestriction(index) {
			this.laneClosureRequest.restriction.splice(index, 1);
		},

		onViewLaneClosureRequest() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ViewLaneClosureRequest", params: { id: this.laneClosureRequest.id } });
			}
		},

		onReportLaneClosure() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ReportClosure", params: { id: this.laneClosureRequest.id } });
			}
		},

		onReportRestriction() {
			if (this.laneClosureRequest.id) {
				this.$router.push({ name: "ReportRestriction", params: { id: this.laneClosureRequest.id } });
			}
		},

		updateRestrictionList() {

		},

		onFromDateTimeChanged: function(val) {
			if (this.laneClosureRequest.fromDate.value && val) {
				let fromTime = this.moment(val);
				let fromDate = this.moment(this.laneClosureRequest.fromDate.value);
				fromDate.minute(fromTime.minute());
				fromDate.hour(fromTime.hour());
				fromDate.seconds(0);
				// this.laneClosureRequest.fromDate.value = fromDate.format();
			}
		},
		// required fields notifying modal
		modalRequiredFieldClose() {
			this.showRequiredFieldModal = false;
		},

		showErrors(errors) {
			this.submissionStatus = 'submission-error';
			this.modalRequiredFieldList = [];
			for (let field in errors) {
				this.modalRequiredFieldList.push(errors[field]);
			}
			this.showRequiredFieldModal = true;
		},

		onSwipeRight() {
			// if the sub transitions are open, close them, otherwise go back.
			if (this.anyExpanded()) {
				Vue.prototype.$bus.$emit("swipe:right:panel",null);
			} else {
				this.$router.go(-1);
			}
		},

		onSubmitOnly(evt) {
			this.onSubmit(evt);
		},
		onCancel() {
			let lastPage = this.$routerStore.getters['getLastListPage'];
			if (lastPage == null) {
				this.$router.push({ name: "ViewLaneClosureRequest", params: { id: this.laneClosureRequest.id } });
			} else {
				this.$router.push(lastPage);
			}
		},
		onSubmit(evt) {
			if (!this.savingAndSet) {
				this.saving = true;
			}
			evt.preventDefault()
			if (!this.validateFields()) {
				this.showUnsavedChangesModal = false
				this.saving = false;
				return new Promise(function(resolve,reject){
					that.onSubmitPromiseDeferred.resolve = resolve;
					that.onSubmitPromiseDeferred.reject = reject;
					reject();
				});
			}
			let that = this;
			return new Promise(function(resolve, reject) {
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				if (that.restriction.id) {
					that.PutRestrictionReport(that.restriction);
				} else {
					that.PostRestrictionReport(that.restriction);
				}
			});

		},

		PostRestrictionReport(t) {
			this.isButtonDisabled = true;
			if (t instanceof Restriction) {
				let go = true;
				if (go) {
					Vue.prototype.$http({
						method: 'post',
						url: `${this.$store.state.apiUrl}/lane-closure-request/${this.laneClosureRequest.id}/report-restriction?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
						data: t.getRawValue()
					}).then(resp => {
						// Handle Success
						this.restriction.id = resp.data.id;
						this.submitted = 1;
						this.saveState = 'success';
						this.submissionStatus = 'submission-success';
						this.showUnsavedChangesModal = false;
						this.SaveNewSuccess();
						this.onSubmitPromiseDeferred.resolve();
					}).catch(error => {
						this.saveState = 'fail';
						this.isButtonDisabled = false;
						this.saving = false;
						if (error) {
							Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
						}

						// if (!ErrorHandler.HasLoginErrorCode(error)) {
						// 	// this.laneClosureRequest.SetErrors(error.response.data);
						// 	this.showErrors(error.response.data.fields);
						// } else {
						// 	// ErrorHandler.RedirectToLogin();
						// }
						this.onSubmitPromiseDeferred.reject();
					}).finally(() => {
						this.isButtonDisabled = false;
					});
				}
			}
		},
		PutRestrictionReport(t) {
			this.isButtonDisabled = true;
			if (t instanceof LaneClosureRequest) {
				Vue.prototype.$http.put({
					url: `${this.$store.state.apiUrl}/lane-closure-request/${t.id}?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: t.getRawValue()
				}).then(() => {
					this.saveState = 'success';
					this.submissionStatus = 'submission-success';
					this.SaveExistingSuccess();
					this.onSubmitPromiseDeferred.resolve();
				}).catch(error => {
					this.saveState = 'fail';
					this.isButtonDisabled = false;
					if (error) {
						Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
					}

					// if (error) {
					// 	if (error.response) {
					// 		if (!ErrorHandler.HasLoginErrorCode(error)) {
					// 			// this.laneClosureRequest.SetErrors(error.response.data);
					// 			this.showErrors(error.response.data.fields);
					// 		} else {
					// 			ErrorHandler.RedirectToLogin();
					// 		}
					// 	}
					// }
					this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},

		SaveExistingSuccess() {
			// TODO: Show thank you message?
			this.savingAndSet = false;
			this.saving = false;
			this.laneClosureRequest.SetErrors({});
			this.restriction.saveChanges();
			this.submitted = true;
			if (this.setClosuresAfter) {
				this.$router.push({ name: "ReportClosure", params: { id: this.laneClosureRequest.id } });
			} else {
				let lastPage = this.$routerStore.getters['getLastListPage'];
				if (lastPage == null) {
					this.$router.push({ name: "ViewLaneClosureRequest", params: { id: this.laneClosureRequest.id } });
				} else {
					this.$router.push(lastPage);
				}
			}

		},

		SaveNewSuccess() {
			// TODO: Show thank you message?
			this.submitted = 1;
			this.saveSuccess = 2;
			this.savingAndSet = false;
			this.saving = false;
			this.restriction.saveChanges();

			if (this.setClosuresAfter) {
				this.$router.push({ name: "ReportClosure", params: { id: this.laneClosureRequest.id } });
			} else {
				let lastPage = this.$routerStore.getters['getLastListPage'];
				if (lastPage == null) {
					this.$router.push({ name: "ViewLaneClosureRequest", params: { id: this.laneClosureRequest.id } });
				} else {
					this.$router.push(lastPage);
				}
			}
		},


		SearchReporter(input) {
			return new Promise((resolve, reject) => {
				// 	if (input.length < 3) {
				// 		return resolve([])
				// }
				Vue.prototype.$http.get(this.$store.state.apiUrl + '/organization/users/level-assignable?q=' + encodeURI(input))
					.then(resp => {
						resolve(resp.data)
					})
					.catch(error => {
						reject(error)
					})
			})
		},
		SearchReporterValue(result) {
			return result.firstName
		},
		// Addeds a transaction line with contact attached.
		HandleSelectReporter(selected) {
			this.reporter = selected;
			this.reporterId = selected.id;
			this.$refs.searchReporter.value = "";
		},

		validateFields() {
			let flag = true;
			let lcValid = this.restriction.validate();
			if (lcValid) { //  && restrictValid

				let closureDate = this.moment(this.restriction.fromDateTime.getRawValue());
				let lcrFromDate = this.moment(this.laneClosureRequest.fromDate.getRawValue());
				// let lcrToDate = this.moment(this.laneClosureRequest.toDate.getRawValue());
				let now = this.moment();
				if (now < closureDate) {
					this.restriction.fromDateTime.status = false;
					this.restriction.fromDateTime.invalidMessage = "Reporting date and time cannot be in the future";
					flag = false;
				}
				let validClosureDate = this.moment(lcrFromDate).subtract(1, 'days').startOf('day');
				if (validClosureDate > closureDate) {
					this.restriction.fromDateTime.status = false;
					this.restriction.fromDateTime.invalidMessage = "Reporting date and time cannot be earlier than 12 AM one day before the lane closure request Start date.";
					flag = false;
				}
				// if (lcrFromDate > closureDate) {
				// 	this.restriction.fromDateTime.status = false;
				// 	this.restriction.fromDateTime.invalidMessage = "Reporting date and time cannot be before the lane closure request Start date.";
				// 	flag = false;
				// }
				return flag;
			}
			return false;
		},

		checkLessThanTwoHours() {
			if (this.projectTimeDuration != null) {
				if (this.projectTimeDuration <= 0) {
					this.laneClosureRequest.toTime.invalidMessage = 'Estimated completion time cannot be earlier than requested start time';
					this.laneClosureRequest.toTime.status = false;
				} else if (this.projectTimeDuration < 2) {
					if (this.laneClosureRequest.isUnderTwoHours.value === false || this.laneClosureRequest.isUnderTwoHours.value === null) {
						this.lessThanTwoHourModalp1 = 'Estimated completion time is set to within two hours of requested start time.';
						this.lessThanTwoHourModalp2 = 'Do you want to set "Closure take less than 2 hours of total time" to "yes"?';
						this.showLessThanTwoHourModal = true;
					}
				} else {
					if (this.laneClosureRequest.isUnderTwoHours.value === true || this.laneClosureRequest.isUnderTwoHours.value === null) {
						this.lessThanTwoHourModalp1 = 'Estimated completion time is set to beyond two hours of requested start time.';
						this.lessThanTwoHourModalp2 = 'Do you want to set "Closure take less than 2 hours of total time" to "no"?';
						this.showLessThanTwoHourModal = true;
					}
				}
			}
		},

		lessThanTwoHoursModalOkClick() {
			if (this.projectTimeDuration != null) {
				if (this.projectTimeDuration < 2) {
					this.laneClosureRequest.isUnderTwoHours.value = true;
				} else if (this.projectTimeDuration > 2) {
					this.laneClosureRequest.isUnderTwoHours.value = false;
				}
			}
		},
		deleteAllMarkers() {
			//Loop through all the markers and remove
			for (var i = 0; i < this.markers.length; i++) {
				this.markers[i].setMap(null);
			}
			this.markers = [];
		},
		LoadLaneClosureRequest(id = this.id) {
			Vue.prototype.$bus.$emit("map:clear", 1);
			this.loaded = false;
			// Remove any messages being displayed.
			this.submissionStatus = null;

			if (id && Format.TryParseInt(id) > 0) {
				this.GetLaneClosureRequest(id);
			} else {
				if (this.data) {
					this.laneClosureRequest = new LaneClosureRequest(this.data);
					this.laneClosureRequest.saveChanges();
					this.$store.commit('laneClosureRequest/setData', this.laneClosureRequest);
				} else {
					this.laneClosureRequest = new LaneClosureRequest();
					// {useTestData:true}
				}
				this.loaded = true;
			}
		},
		// Loads lane closure request into the component based on provided id.
		GetLaneClosureRequest(id) {
			let that = this;
			if (Format.TryParseInt(id)) {
				this.loaded = false;
				Vue.prototype.$http({
					method: 'get',
					url: `${this.$store.state.apiUrl}/lane-closure-request/${id}/report-restriction?r=${Math.round(Math.random() * Math.pow(10, 6))}`
				}).then(response => {
					// populate the lane closure request
					this.laneClosureRequest = new LaneClosureRequest(response.data.request);
					this.downloadToken = response.data.downloadToken;
					this.downloadTokenExpires = response.data.downloadTokenExpires;

					let fromDateTime = this.moment();
					fromDateTime.seconds(0);

					// populate the lane closure with data from the lane closure request.
					if (response.data.closure) {
						let newData = {
							id: null,
							lcrId: response.data.closure.lcrId || null,
							ownerId: response.data.closure.ownerId || null,
							reporterId: response.data.closure.reporterId || null,
							fromDateTime: fromDateTime.format() || null,
							toDateTime: response.data.closure.toDateTime || null,
							inEffect: typeof response.data.closure.inEffect === 'number' ? response.data.closure.inEffect : null,
							numberLanesOpen: response.data.closure.numberLanesOpen || null,
							numberLanesClosed: response.data.closure.numberLanesClosed || null,
							trafficEffect: response.data.request.trafficEffect || null,
							block: response.data.request.block
						}
						// whoever is logged in is actually doing the reporting...
						that.reporter = that.$store.getters.userInfo();
						newData.reporterId = that.$store.getters.userId();

						that.restriction = new Restriction(newData);
					} else {
						// use the data from the lane closure request.
						let newData = {
							id: null,
							lcrId: response.data.request.id || null,
							ownerId: response.data.request.ownerId || null,
							reporterId: response.data.request.reporterId || null,
							fromDateTime: fromDateTime.format() || null,
							toDateTime: response.data.request.toDate || null,
							inEffect: typeof response.data.request.inEffect === 'number' ? response.data.request.inEffect : null,
							numberLanesOpen: response.data.request.numberLanesOpen || null,
							numberLanesClosed: response.data.request.numberLanesClosed || null,
							trafficEffect: response.data.request.trafficEffect || null,
							block: response.data.request.block
						};
						if (response.data.request.closureReporter == null) {
							this.reporter = response.data.request.requester;
							newData.reporterId = this.reporter.userId;
						} else {
							this.reporter = response.data.request.closureReporter;
							newData.reporterId = this.reporter.userId;
						}
						this.restriction = new Restriction(newData);
					}

					this.loaded = true;

					if (this.restriction.block) {
						let x = 0;
						for (x = 0; x < this.restriction.block.length; x++) {
							this.setBlockPolyline(this.restriction.block[x]);
						}
						this.zoomAllBlocks();
					}
					this.restriction.saveChanges();


				}).catch(error => {
					this.isButtonDisabled = false;
					this.loaded = false;
					if (error) {
						Vue.prototype.$bus.$emit("error:network", {error:error,submitted:null});
					}
					// if (!ErrorHandler.HasLoginErrorCode(error)) {
					// 	if (error.response && error.response.data) {
					// 		this.loaded = false;
					// 		this.transactionStatus = 'load-error';
					// 		this.errorDetails = error.response.data;
					// 	}
					// } else {
					// 	// ErrorHandler.RedirectToLogin();
					// }
				});
			}
		},

		changeToHideMap() {
			this.hideMap = true;
		},
		changeToShowMap() {
			this.currentBlockOnMap = null;
			this.hideMap = false;
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			Vue.prototype.$bus.$emit("map:clear", 1);
			// Vue.prototype.$bus.$emit("map:showMapWhenDesktop");
		});
	},
	beforeRouteLeave(to, from, next) {
		if (this.loaded && this.restriction.hasChanges()) {
			if (this.overrideUnsavedChanges) {
				Vue.prototype.$bus.$emit("map:clear", 1);
				this.setEventBusOff();
				next(true);
			} else {
				this.showUnsavedChangesModal = true;
				this.modalOnSave = (function() {
					this.onSubmit().then(() => {
						this.showUnsavedChangesModal = false;
						Vue.prototype.$bus.$emit("map:clear", 1);
						this.setEventBusOff();
						next(true);
					}).catch(() => {
						next(false);
					});
				}).bind(this);

				this.modalOnLeave = (function() {
					this.showUnsavedChangesModal = false;
					Vue.prototype.$bus.$emit("map:clear", 1);
					this.setEventBusOff();
					next(true);
				}).bind(this);

				next(false);
			}
		} else {
			Vue.prototype.$bus.$emit("map:clear", 1);
			this.setEventBusOff();
			next(true);
		}
	},
}
</script>